import React from "react";

import * as S from "./styles";
import { AiOutlineCalendar, AiOutlineEye } from "react-icons/ai";

import cpfIcon from "@assets/cpfIcon.svg";
import { GoDotFill } from "react-icons/go";
import { MdReplay } from "react-icons/md";
import { RemoveHistory } from "@domain/models/RemoveHistory";
import { reportResultOptions } from "@domain/models/Report";
import { datetimeHelper } from "@helpers/datetime";

type Props = {
  data: RemoveHistory;
  onView: () => void;
  onUndo: () => void;
};

export default function HistoryListItem({ data, onView, onUndo }: Props) {
  const color =
    data.result === reportResultOptions.SIGNED ||
    data.result === reportResultOptions.RECOMMENDATION_SIGNED
      ? "var(--success)"
      : data.result === reportResultOptions.RETURN
        ? "var(--yellow)"
        : "var(--red)";

  return (
    <S.Container>
      <div>
        <h4>{data.undo ? data.undo.userName : data.userName}</h4>
      </div>
      <div>
        <S.Status undo={data.undo ? true : false}>{data.undo ? "Desfeita" : "Concluída"}</S.Status>
      </div>
      <div>
        <GoDotFill size={10} color={color} />
        <S.TextResult color={color}>{data.result}</S.TextResult>
      </div>
      <div>
        <h4>{data.description}</h4>
      </div>
      <div>
        <AiOutlineCalendar color="var(--grey2)" />
        <h4>{datetimeHelper.getDate(data.createdAt)}</h4>
      </div>
      <div>
        <img src={cpfIcon} alt="cpf" />
        <h4>{data.removedClients}</h4>
      </div>
      <div>
        <img src={cpfIcon} alt="cpf" />
        <h4>{data.notRemovedClients}</h4>
      </div>
      <div>
        <img src={cpfIcon} alt="cpf" />
        <h4>{data.removedClients + data.notRemovedClients}</h4>
      </div>
      <div>
        <AiOutlineEye
          onClick={onView}
          cursor="pointer"
          size={18}
          color="#808B9F"
          fill="#808B9F"
          style={{ marginLeft: 10 }}
        />
        {!data.undo && (
          <MdReplay
            onClick={onUndo}
            cursor="pointer"
            size={18}
            color="#808B9F"
            fill="#808B9F"
            style={{ marginLeft: 10 }}
          />
        )}
      </div>
    </S.Container>
  );
}
